module.exports = __webpack_public_path__ + "static/media/created.460b0bb8.svg";